// One root for every billing-providers query (§8), so invalidating ['billing-providers']
// reaches the list, the detail and the channel options. The detail key used to be
// ['billing-provider', id], outside that root, so a row Enable/Disable left the detail
// page stale.
export const billingProvidersQueryKeys = {
    all: ['billing-providers'] as const,
    list: (filters: Record<string, string>) => ['billing-providers', 'list', filters] as const,
    detail: (id?: string) => ['billing-providers', 'detail', id] as const,
    channelOptions: () => ['billing-providers', 'channel-options'] as const,
};
